/**
 * Features related to pages
 * @module services/pages
 */
import { Map } from 'immutable'

/**
 * Given the page state return true if it is ready
 * @param {Object} param0 The parameters
 * @param {Map} param0.page The parameters
 * @returns {Boolean} True if the page state is ready
 */
export function isPageReady ({ page } = {}) {
  if (!Map.isMap(page)) {
    throw new Error('The page paramter is required to be a Map')
  }
  return page.get('ready') || false
}
